
export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-black mb-4">
            SOBRE NÓS
          </h2>
          <div className="w-24 md:w-32 h-2 bg-yellow-400 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-red-600 rounded-3xl transform rotate-3"></div>
            <img
              src="https://public.readdy.ai/ai/img_res/33da04429d2547eaf78ebb40829f5aa1.jpg"
              alt="Sobre Buckets Chicken"
              className="relative rounded-3xl shadow-2xl w-full h-56 sm:h-72 md:h-full object-cover"
            />
          </div>

          <div className="space-y-5 md:space-y-6">
            <p className="text-base md:text-lg text-gray-800 leading-relaxed">
              <strong className="text-red-600">Buckets Chicken</strong> é a sua nova experiência em frango frito delivery! Preparamos cada pedaço com carinho e dedicação, usando receitas exclusivas que garantem aquela crocância irresistível por fora e suculência por dentro.
            </p>

            <p className="text-base md:text-lg text-gray-800 leading-relaxed">
              Nossa missão é levar até você o melhor frango frito da cidade, sempre fresquinho e quentinho. Usamos apenas ingredientes selecionados e temperos especiais que fazem toda a diferença no sabor.
            </p>

            <div className="grid grid-cols-2 gap-4 md:gap-6 pt-4 md:pt-6">
              <div className="bg-red-600 p-4 md:p-6 rounded-2xl text-center transform hover:scale-105 transition-transform duration-300">
                <i className="ri-restaurant-line text-3xl md:text-5xl text-yellow-400 mb-2 md:mb-3"></i>
                <h3 className="text-lg md:text-2xl font-bold text-white mb-1 md:mb-2">Receita Secreta</h3>
                <p className="text-white text-xs md:text-sm">Temperos exclusivos</p>
              </div>

              <div className="bg-black p-4 md:p-6 rounded-2xl text-center transform hover:scale-105 transition-transform duration-300">
                <i className="ri-heart-fill text-3xl md:text-5xl text-yellow-400 mb-2 md:mb-3"></i>
                <h3 className="text-lg md:text-2xl font-bold text-white mb-1 md:mb-2">Feito com Amor</h3>
                <p className="text-white text-xs md:text-sm">Qualidade garantida</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
